import React from 'react';
import { Stage, Link, SiteFooter } from '../components/Site';
import ApplyForm from '../components/ApplyForm';
import { APPLY_PHOTO } from '../siteData';

// The shareable page for the general resume link (/apply): one photo, one form.
// Soch Tools matches the resume to every opening.
const PHOTOS = { apply: APPLY_PHOTO };

export default function GeneralApply() {
  return (
    <div className="split apply-page">
      <Stage photos={PHOTOS} activeKey="apply" wordmark={false} />
      <main className="col" id="top">
        <div className="brandline"><Link to="/" className="mark">Soch</Link></div>
        <section className="intro" aria-labelledby="h1">
          <h1 id="h1">Send us your resume</h1>
          <p className="lead">Not sure which role fits? Send your resume and we will match it to the right opening, now or when one opens up.</p>
        </section>
        <div className="apply solo">
          <ApplyForm title="Your details" submitLabel="Send my resume" />
        </div>
        <p className="quiet"><Link to="/#roles">See all open roles</Link></p>
        <SiteFooter />
      </main>
    </div>
  );
}
